const de = {
  suffix: ' pro Inserat',
  header: 'Stellenmarkt Preise',
  subheader: '2 Monate Anzeigezeitraum',
  linktext: 'Um die Preise für Anzeigen im Stellenmarkt einzusehen klicken Sie ',
  actuallink: ' hier.',
  buttontext: 'Zur Registrierung',

  freeTitle: 'Kostenfrei',
  freePrice: '0€',
  freeBenefit1: 'Werkstudententätigkeit',
  freeBenefit2: 'Studien- und Abschlussarbeit',
  freeBenefit3: 'Auslandspraktikum',
  freeBenefit4: 'Praktikum',
  freeBenefit5: 'Duales Studium',
  freeBenefit6: 'Nachhilfe',
  freeBenefit7: 'Studentische Hilfskraft',
  freeBenefit8: 'Ehrenamt',

  payTitle: 'Premium',
  payPrice: '80€',
  payBenefit1: 'Jobeinstieg und Trainee',
  payBenefit2: 'Studentenjob',
  payBenefit3: 'Stelle, die erste Berufserfahrung voraussetzt'
};

export default de;
export type PricingSlotsTranslation = typeof de;
